const show_logs = true;
const show_agree_terms = true;

$(function() {
    log('GO-customize loaded');
    if (show_agree_terms) {
        $(document).on('change', '#checkout_accept_terms', function(){
            if(this.checked) {
                $(".newsl_btn").prop("disabled", false);
            } else {
                $(".newsl_btn").prop("disabled", true);
            }
        });  
      
        $(document).on('change', '#checkout_accept_terms_chk', function(){
            if(this.checked) {
                $("#cartCheckout").prop("disabled", false);
            } else {
                $("#cartCheckout").prop("disabled", true);
            }
        }); 
      
        $(document).on('change', '#checkout_accept_terms_contact', function(){
            if(this.checked) {
                $("#submittMsg").prop("disabled", false);
            } else {
                $("#submittMsg").prop("disabled", true);
            }
        }); 
    }

    $(document).on('click', '.remove_all_items', function(){
        log('remove_all_items clicked');
        $("body").addClass("loading");
        $.ajax({
            type: 'POST',
            url: '/cart/clear.js',
            dataType: 'json',
            success: function(cart) {
                log('cart cleared');
                //update cart info
                // $('#cartCount').html(cart.item_count);
                // $('#cart_total').html(Shopify.formatMoney(cart.total_price, window.money_format));
                // //update item qty
                // $('.qty[data-key="'+item_key+'"] input').val(qty);
                $("body").removeClass("loading");
                location.reload();
            }
        });
    });

    /*
    //subscribe to button plus or minus: qtyBtn plus or qtyBtn minus
    $(document).on('click', '.qtyBtn', function(){
        var item_key = $(this).attr('data-key');
        var qty = parseInt($(this).attr('data-qty'));

        console.log('qtyBtn clicked');
        
        //update item cart with new qty
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
                quantity: qty,
                id: item_key
            },
            dataType: 'json',
            success: function(cart) {
                log('cart updated');
                //update cart info
                $('#cartCount').html(cart.item_count);
                $('#cart_total').html(Shopify.formatMoney(cart.total_price, window.money_format));
                //update item qty
                $('.qty[data-key="'+item_key+'"] input').val(qty);
            }
        });
       
    });
    */

});

function log(msg) {
    if (show_logs) {
        console.log(msg);
    }
}

